import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setUsersPayer,
    setUsersParticipant,
    setCurseHadings,
    setStartDate, } from '../../reducers/reposReducers';
import ApiService from '../../services/ApiService';
import { useDispatch, useSelector } from 'react-redux';
import TableHeader from '../pay/tableHeader';
import CustomTittle from '../Elements/customTittle/customTittle';
import "./studentCard.css"
var Barcode = require('react-barcode');
const StudentCard = (props) => {
    useEffect(()=>{
        props.setHeader("/  KARTA KURSANTA")
    },[])
  console.log(props.user)
    return <>
     <div className="dashboard__content">
     <main >
        <div className="barCode_tittle">
        <CustomTittle>Karta kursanta</CustomTittle>
        </div>
        {props.user!=undefined?
        props.user.memberCardNumber!=""?
        <div className='barCode'>
            <div className='barCode_bordered'>
            <Barcode value={props.user.memberCardNumber} 
                     displayValue={false} height={150} width={2}
                     />
         
        </div></div>:<div className='studentCardNull_cointainer'><p className='studentCardNull'>Brak karty członkowskiej</p></div>
        :<div className='studentCardNull_cointainer'><p className='studentCardNull'>Brak karty członkowskiej</p></div>}
    </main>
    </div>
    </>;
    };

export default StudentCard;